import { ui } from 'modules/common';
import { noValue } from 'shared/constants';
import { AccountingDomainEntitiesBudgetCheckPeriod, BudgetsQBooksDimensionType } from 'shared/data/webApp/v2';

import { messages } from './BudgetParams.messages';

export const getSubdivideByText = (dimensionType?: BudgetsQBooksDimensionType) => {
    switch (dimensionType) {
        case BudgetsQBooksDimensionType.customer:
            return messages.customer;
        case BudgetsQBooksDimensionType.location:
            return messages.location;
        case BudgetsQBooksDimensionType.class:
            return messages.class;
        default:
            return messages.dontDivide;
    }
};

export const getCheckPeriodText = (
    checkPeriod: AccountingDomainEntitiesBudgetCheckPeriod,
    checkPeriodFirstMonth?: number
) => {
    const month = ui.allMonthReferences.find((item) => item.monthIndex === checkPeriodFirstMonth);

    switch (checkPeriod) {
        case AccountingDomainEntitiesBudgetCheckPeriod.Monthly:
            return messages.checkPeriodMonthly;

        case AccountingDomainEntitiesBudgetCheckPeriod.Quarterly:
            return messages.checkPeriodQuarterly;

        case AccountingDomainEntitiesBudgetCheckPeriod.Semiannually:
            return messages.checkPeriodHalfYearly;

        case AccountingDomainEntitiesBudgetCheckPeriod.Annually:
            return messages.checkPeriodYearly;

        case AccountingDomainEntitiesBudgetCheckPeriod.YearToDate:
            return messages.checkPeriodYTD;

        case AccountingDomainEntitiesBudgetCheckPeriod.AnnuallyWithCustomFirstMonth:
            return messages.checkPeriodAnnuallyWithCustomFirstMonth({ month: month?.text });

        case AccountingDomainEntitiesBudgetCheckPeriod.YearToDateWithCustomFirstMonth:
            return messages.checkPeriodYearToDateWithCustomFirstMonth({ month: month?.text });

        default:
            return noValue;
    }
};
